<template src="./closed-org-settlement.html">
</template>

<script>
  import Vue from 'vue'
  import { EventBus } from '@/router/bus'
  import Loader from '@/components/misc/Loader'

  export default {
    components: {
      Loader
    },
    data () {
      return {
        load: false,
        errorList: [],
        invoiceIds: null,
        settlementMessage: null
      }
    },
    computed: {
      showErrorContainer () {
        return this.errorList.length > 0
      }
    },
    methods: {
      submitActivation: function (e) {
        var parsedData = []
        this.invoiceIds.split(/\r?\n/).forEach(element => {
          var invoiceId = element.trim()
          if (invoiceId) {
            parsedData.push({ invoiceId: invoiceId })
          }
        })

        if (!parsedData.length) { return }

        var input = {
          liabilities: parsedData,
          SettlementMessage: this.settlementMessage.trim()
        }

        this.load = true

        this.$http.post(Vue.$apiConfig.closedOrganizationSettlementPost, input)
          .then(response => {
            this.errorList = []
            this.logConsole(response)
            this.load = false
            // get body data
            if (!!response.data && Array.isArray(response.data.payload)) {
              response.data.payload.forEach(element => {
                if (element.liabilityError) {
                  this.errorList.push(`${element.liability.invoiceId} : ${element.liabilityError.description}`)
                }
              })
            }
            if (this.errorList.length === 0) {
              EventBus.$emit('alert', {
                variant: 'success',
                message: 'Фактуре успешно измирене',
                errors: []
              })
            }
            this.$refs.registerSettlementForm.reset()
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error, 'invoices.invoiceLimitExceeded')
            this.load = false
          }
          )
          .finally(response => {
            this.invoiceIds = null
          })
      }
    }
  }
</script>

<style lang="scss" type="text/scss" scoped>
  @import '~@/assets/scss/variables.scss';

  .text-dark {
    font-weight: 600;
    font-size: 12pt;
    color: $font-color-dark !important;
  }

  .list-container {
    height: 200px;
    overflow-y: scroll;
    overflow-x:hidden;
    font-size: 11pt;
  }
</style>



// WEBPACK FOOTER //
// ClosedOrgSettlement.vue?46a1ce2e